/**
 * CW Browser text logo — clean typographic brand mark.
 * Props:
 *   size     – font size in px (default 20)
 *   variant  – "dark" (white text, for dark bg) | "light" (navy text, for light bg)
 *   style    – additional container styles
 */
const CWBrowserLogo = ({ size = 20, variant = "dark", style }) => {
  const cwColor = variant === "light" ? "#1B2D4F" : "#ffffff";
  const green = "#8DC63F";

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        fontSize: size,
        fontWeight: 700,
        letterSpacing: 0.5,
        whiteSpace: "nowrap",
        userSelect: "none",
        ...style,
      }}
    >
      <span style={{ color: cwColor, marginRight: size * 0.3 }}>CW</span>
      <span style={{ color: green }}>Browser</span>
    </span>
  );
};

export default CWBrowserLogo;
